import { ReactNode } from "react";

import { Popover } from "antd";
import styled from "styled-components";

import {
  TRIGGER_MODES,
  UseRightClickContextMenuReturn
} from "../hooks/useRightClickContextMenu";

interface ContextMenuPopoverProps {
  actionList: ReactNode; // Pre-built action list from the Actions component
  contextMenu?: UseRightClickContextMenuReturn;
}

export function ContextMenuPopover({
  actionList,
  contextMenu
}: ContextMenuPopoverProps): JSX.Element | null {
  const triggerMode = contextMenu?.triggerMode || TRIGGER_MODES.BUTTON;
  const contextMenuVisible = contextMenu?.contextMenuState?.visible || false;
  const contextMenuPosition = contextMenu?.contextMenuState?.position || { x: 0, y: 0 };

  if (triggerMode !== TRIGGER_MODES.CONTEXT_MENU || !contextMenuVisible) {
    return null;
  }

  return (
    <Popover
      content={actionList}
      open={true}
      onOpenChange={(visible) => {
        if (!visible && contextMenu?.onContextMenuClose) {
          contextMenu.onContextMenuClose();
        }
      }}
      overlayClassName="popover-no-padding"
      placement="bottomLeft"
      trigger="click"
      getPopupContainer={() => document.body}>
      <ContextMenuTrigger x={contextMenuPosition.x} y={contextMenuPosition.y} />
    </Popover>
  );
}

// Invisible trigger positioned at mouse coordinates for context menu
const ContextMenuTrigger = styled.div<{ x: number; y: number }>`
  position: fixed;
  top: ${(props) => props.y}px;
  left: ${(props) => props.x}px;
  width: 1px;
  height: 1px;
  visibility: hidden;
  pointer-events: none;
  z-index: 1000;
`;
